import { type ReactElement } from 'react'
import { Alert, type AlertProps } from '@mantine/core'
import { type MaterialSymbolType, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '../icon'
export type TAlertVariant = 'basic' | 'default' | 'discovery' | 'success' | 'warning' | 'error'

type TAlertProps = Omit<AlertProps, 'icon'> & {
  variant?: TAlertVariant
  noIcon?: boolean
}

export const TAlert = ({ variant = 'default', noIcon = false, ...props }: TAlertProps): ReactElement => {
  const { t } = useTranslation()
  return (
    <Alert
      closeButtonLabel={t('Close')}
      color={props.color ?? getColor(variant)}
      icon={noIcon ? undefined : <MaterialSymbolIcon icon={getIcon(variant)} />}
      {...props}
    />
  )
}

const getIcon = (variant: TAlertVariant): MaterialSymbolType => {
  switch (variant) {
    case 'basic':
    case 'default':
    case 'discovery':
      return 'info'
    case 'success':
      return 'check_circle'
    case 'warning':
      return 'warning'
    case 'error':
      return 'error'
  }
}

const getColor = (variant: TAlertVariant): string => {
  switch (variant) {
    case 'basic':
    case 'default':
    case 'discovery':
      return 'brand'
    case 'success':
      return 'emerald'
    case 'warning':
      return 'yellow'
    case 'error':
      return 'rose'
  }
}
